'use client';

import { c as _c } from "react/compiler-runtime";
import map from '@images/renders/bg_images/Map.webp';
import ROUTES from '@lib/constants/routes';
import { handleStartPanoramaPreload } from '@lib/store/slices/ComponentsSlice';
import { infoAboutProject } from '@lib/tools/helpers/constants';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import { animated, useInView } from '@react-spring/web';
import cn from 'classnames';
import NextImage from 'next/image';
import Link from 'next/link';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import style from './FavoriteMoments.module.scss';
function FavoriteMoments(t0) {
  const $ = _c(38);
  const {
    isMobile
  } = t0;
  const dispatch = useDispatch();
  const [titleRef, titleInView] = useInView();
  const [textRef, textInView] = useInView();
  const [boxRef, boxInView] = useInView();
  const getView = _temp;
  let t1;
  let t2;
  if ($[0] !== dispatch) {
    t1 = () => {
      dispatch(handleStartPanoramaPreload(true));
    };
    t2 = [dispatch];
    $[0] = dispatch;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={style.mapBox}><NextImage className={style.map} src={map} fill={true} alt={"\u041A\u0430\u0440\u0442\u0430"} /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== titleInView) {
    t4 = getView(titleInView);
    $[4] = titleInView;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p>Транспортная</p>;
    t6 = <p>свобода</p>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4) {
    t7 = <div className={style.title_box} style={t4}>{t5}{t6}</div>;
    $[8] = t4;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7 || $[11] !== titleRef) {
    t8 = <animated.div className={style.title} ref={titleRef}>{t7}</animated.div>;
    $[10] = t7;
    $[11] = titleRef;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== textInView) {
    t9 = getView(textInView);
    $[13] = textInView;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isMobile) {
    t10 = isMobile ? <><br /> <br /></> : null;
    $[15] = isMobile;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <p>Меньше времени на дорогу, а значит, больше времени для себя и близких.{t10}До центра из Моментс, расположенного на северо-западе рядом с парком Покровское-Стрешнево, можно с комфортом добраться за 15 минут на всех видах транспорта.</p>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Link href={ROUTES.location} className={cn(style.link)}>Смотреть расположение</Link>;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t9) {
    t13 = <div className={style.description_box} style={t9}>{t11}{t12}</div>;
    $[20] = t11;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13 || $[24] !== textRef) {
    t14 = <animated.div className={style.description} ref={textRef}>{t13}</animated.div>;
    $[23] = t13;
    $[24] = textRef;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== boxInView) {
    t15 = getView(boxInView);
    $[26] = boxInView;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = infoAboutProject?.map(_temp2);
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t15) {
    t17 = <ul className={style.bottomInfo_box} style={t15}>{t16}</ul>;
    $[29] = t15;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== boxRef || $[32] !== t17) {
    t18 = <animated.div className={style.bottomInfo} ref={boxRef}>{t17}</animated.div>;
    $[31] = boxRef;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t14 || $[35] !== t18 || $[36] !== t8) {
    t19 = <><div className={style.wrapper}>{t3}{t8}{t14}{t18}</div></>;
    $[34] = t14;
    $[35] = t18;
    $[36] = t8;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  return t19;
}
function _temp2(item) {
  return <li key={item.id} className={style.bottomInfo_piece}><span data-start-number={item.title + 20} className={style.bottomInfo_time}>{item.title} мин</span><SafeHtmlRenderer tag="p" content={item?.info || ""} className={style.bottomInfo_description} /></li>;
}
function _temp(view) {
  return {
    opacity: view ? 1 : 0,
    transition: "1s ease",
    paddingTop: view ? 0 : 80
  };
}
export default FavoriteMoments;